import { useState } from 'react'

import { MessageBox, Space, Tabs } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { StrategyAttributes } from '../../05-complete/organisms/approval/strategy'

const TradeEditStrategyDetailsSummary = () => {
  const strategy = useAppSelector(state => state.strategy)
  const [selectedTab, setSelectedTab] = useState<string>('pending')

  const onTabClick = (tabName: string) => {
    setSelectedTab(tabName)
  }

  const hasPendingState = strategy.readonlyPendingState && strategy.readonlyPendingState.type

  if (strategy.isInited) {
    return (
      <Space mx={5} my={6}>
        <Tabs.List>
          <Tabs.Tab
            isSelected={selectedTab === 'pending'}
            value="pending"
            onClick={() => onTabClick('pending')}
          >
            Incoming changes
          </Tabs.Tab>
          <Tabs.Tab
            isSelected={selectedTab === 'current'}
            value="current"
            onClick={() => onTabClick('current')}
          >
            Current
          </Tabs.Tab>
        </Tabs.List>
        {selectedTab === 'pending' && (
          <Tabs.Panel className="my-6" value="pending">
            {hasPendingState && (
              <Space mx={5}>
                <StrategyAttributes isApproved strategy={strategy.readonlyPendingState} />
              </Space>
            )}
            {!hasPendingState && (
              <MessageBox state="disabled">No changes have been made to the strategy</MessageBox>
            )}
          </Tabs.Panel>
        )}
        {selectedTab === 'current' && (
          <Tabs.Panel className="mx-5 my-6" value="current">
            <StrategyAttributes isApproved strategy={strategy.readonlyCurrentState} />
          </Tabs.Panel>
        )}
      </Space>
    )
  }
}

export default TradeEditStrategyDetailsSummary
